import i18n from "../i18n";

import { isSingleDepotMode } from "./restaurant";

import { defaultControlCenterColors } from "../utils/constants";
import { getFormatRelativeTime } from "../utils/convertTime";
import {DEEP_LINK_EVENT} from "../utils/enums";

export function getControlCentersChartModelData(data) {
  if(!data || !data.controlCenterStatistics || !data.controlCenterStatistics.length) return null;
  return {
    headers: [
      { type: "string", label: i18n.t("header.menu.CONTROL_CENTERS") },
      { type: "number", label: i18n.t("reports.TOTAL_NUMBER_OF") },
      { type: "number", label: i18n.t("reports.MARKETPLACE_ORDERS") },
      { type: "number", label: i18n.t("reports.SUCCESS_TOTAL") },
      { type: "number", label: i18n.t("reports.NUMBER_IN_PROCESS") },
      { type: "number", label: i18n.t("reports.ORDERS_SECCESSFULY_DELIVERED") },
      { type: "number", label: i18n.t("reports.ORDERS_WERE_CANCELED") },
      { type: "number", label: i18n.t("reports.FAILED") },
      { type: "number", label: i18n.t("controlCenters.COURIERS_ON_SHIFT_LABEL") },
      { type: "number", label: i18n.t("controlCenters.SHIFT_HOURS_LABEL") },
      // { type: "number", label: i18n.t("reports.UNASSIGNED_ORDERS") },
      // { type: "number", label: i18n.t("reports.WAITING_COURIERS") }
    ],
    columns: data.controlCenterStatistics.map(statistic => [
      statistic.name,
      statistic.ordersCount,
      statistic.marketplaceOrdersCount,
      statistic.deliveredOrders,
      statistic.inProccessOrdersCount,
      statistic.deliveredOrdersCount,
      statistic.canceledOrdersCount,
      statistic.notDeliveredOnTimeOrdersCount,
      statistic.countCouriers,
      statistic.shiftHours,
      // statistic.unassignedOrders,
      // statistic.waitingCouriers
    ])
  };
}

export function getDepotChartModelData(data) {
  if(!data || !data.depotStatistics || !data.depotStatistics.length) return null;
  return {
    headers: [
      { type: "string", label: i18n.t("reports.DEPOT") },
      { type: "number", label: i18n.t("reports.TOTAL_NUMBER_OF") },
      { type: "number", label: i18n.t("reports.MARKETPLACE_ORDERS") },
      { type: "number", label: i18n.t("reports.SUCCESS_TOTAL") },
      { type: "number", label: i18n.t("reports.NUMBER_IN_PROCESS") },
      { type: "number", label: i18n.t("reports.ORDERS_SECCESSFULY_DELIVERED") },
      { type: "number", label: i18n.t("reports.ORDERS_WERE_CANCELED") },
      { type: "number", label: i18n.t("reports.FAILED") },
      { type: "number", label: i18n.t("controlCenters.COURIERS_ON_SHIFT_LABEL") },
      { type: "number", label: i18n.t("controlCenters.SHIFT_HOURS_LABEL") },
      { type: "number", label: i18n.t("reports.UNASSIGNED_ORDERS") },
      { type: "number", label: i18n.t("reports.WAITING_COURIERS") }
    ],
    columns: data.depotStatistics.map(statistic => [
      statistic.name,
      statistic.ordersCount,
      statistic.marketplaceOrdersCount,
      statistic.deliveredOrders,
      statistic.inProccessOrdersCount,
      statistic.deliveredOrdersCount,
      statistic.canceledOrdersCount,
      statistic.notDeliveredOnTimeOrdersCount,
      statistic.countCouriers,
      statistic.shiftHours,
      statistic.unassignedOrders,
      statistic.waitingCouriers
    ])
  };
}

export function getInProcessOrdersChartModelData(data) {
  if(!data || !data.controlCenterStatistics || !data.controlCenterStatistics.length) return null;
  return {
    headers: [
      { type: "string", label: i18n.t("header.menu.CONTROL_CENTERS") },
      { type: "number", label: i18n.t("reports.TOTAL") }
    ],
    columns: data.controlCenterStatistics.reduce((accumulator, statistic) => {
      if (statistic.inProccessOrdersCount) {
        accumulator.push([statistic.name, statistic.inProccessOrdersCount]);
      }
      return accumulator;
    }, [])
  };
}

export function getAverageOrdersChartModelData(data) {
  if(!data || !data.controlCenterStatistics || !data.controlCenterStatistics.length) return null;
  return {
    headers: [
      { type: "string", label: i18n.t("header.menu.CONTROL_CENTERS") },
      { type: "number", label: i18n.t("reports.ORDERS_PER_HOUR") },
      { role: "style" },
      { role: "annotation" },
      { type: "number", label: i18n.t("reports.CONTROL_CENTER_DELIVERY_FEE") },
      { role: "style" },
      { role: "annotation" },
    ],
    columns: data.controlCenterStatistics.map((statistic, index) => [
      statistic.name,
      statistic.ordersScore,
      defaultControlCenterColors[index],
      statistic.ordersScore,
      statistic.controlCenterDeliceryFee,
      defaultControlCenterColors[index],
      statistic.controlCenterDeliceryFee,
    ])
  };
}

export function getControlCentersAverageDeliveryTimeChartModelData(data) {
  if(!data || !data.controlCentersAverageDeliveryTime || !data.controlCentersAverageDeliveryTime.length) return null;
  return {
    headers: [
      { type: "string", label: i18n.t("header.menu.CONTROL_CENTERS") },
      { type: "number", label: i18n.t("reports.CONTROL_CENTERS_AVERAGE_DELIVERY_TIME_LABEL") },
      { role: "style" },
      { role: "annotation" }
    ],
    columns: data.controlCentersAverageDeliveryTime.map((statistic, index) => [
      statistic.controlCenterName,
      statistic.averageDeliveryTime,
      defaultControlCenterColors[index],
      statistic.averageDeliveryTime,
    ])
  };
}


export function getAverageOrdersPerHoursChartModelData(data) {
  return {
    headers: [],
    columns: ["", data.ordersScore]
  };
}

export function getAverageOrdersPerOrderChartModelData(data) {
  return {
    headers: [],
    columns: ["", data.ordersScorePerOrder]
  };
}

export function getAverageOrdersMoneyPerOrderChartModelData(data) {
  return {
    headers: [],
    columns: ["", data.ordersMoneyPerOrder]
  };
}

export function getAverageOrdersHourlyChartModelData(data) {
  return {
    headers: [],
    columns: ["", data.ordersScoreHourly]
  };
}

export function getReportDeliveryTimeItemsChartModelData(data) {
  if(!((((data || {}).reportDeliveryTimeStatistics || [])[0] || {}).values || []).length) return null;
  return checkIsPeriod(data)
    ? getReportDeliveryTimeItemsPeriodChartModelData(data)
    : getReportDeliveryTimeItemsDayChartModelData(data);
}

export function getReportDeliveryTimeItemsDayChartModelData(data) {
  let columns = [];
  let headers = [i18n.t("reports.DELIVERY_TIME")];

  data.reportDeliveryTimeStatistics[0].values.forEach(val => {
    headers.push(val.controlCenter);
    headers.push({ type: "string", role: "style" });
  });
 
  if(data.reportDeliveryTimeStatistics.some(statistic => statistic.values.length)) {
    data.reportDeliveryTimeStatistics.forEach(statistic=> {
      let newColumns = [];
      newColumns.push(statistic.time);
      statistic.values.forEach((val, index)=> {
        newColumns.push(val.countOrders); 
        newColumns.push(defaultControlCenterColors[index]);
      });

      columns.push(newColumns);
    });
  } else {
    columns = data.reportDeliveryTimeStatistics.map(statistic => [statistic.time, 0]);
  }

  return { headers, columns };
}

export function getReportDeliveryTimeItemsPeriodChartModelData(data) {
  const controlCenters = (data.reportDeliveryTimeStatistics || []).reduce((acc, statistic)=> {
    const newControlCenters = statistic.values
      .filter(f=> checkReportControlCenter(f.controlCenterId) && !acc.find(a=> a.controlCenterId === f.controlCenterId))
      .map((m, index)=> ({ 
        controlCenterId: m.controlCenterId, 
        controlCenter: m.controlCenter,
        color: defaultControlCenterColors[index]
      }))
    return acc.concat(newControlCenters);
  }, []);

  const headers = [i18n.t("reports.DELIVERY_TIME")];
  let columns = [];
  controlCenters.forEach(val=> {
    headers.push(val.controlCenter);
    headers.push({ type: "string", role: "style" });
    headers.push({ type: "string", role: "tooltip" });  
  });

  if(!controlCenters.length) {
    return null;
  }
  
  if(data.reportDeliveryTimeStatistics.some(statistic => statistic.values.length)) {
    data.reportDeliveryTimeStatistics.forEach(statistic=> {
      let newColumns = [];
      newColumns.push(statistic.date);
      statistic.values.forEach((val, index)=> {
        if(checkReportControlCenter(val.controlCenterId)) {
          const cc = controlCenters.find(f=> f.controlCenterId === val.controlCenterId);
          newColumns.push(val.countOrders); 
          newColumns.push(cc.color || defaultControlCenterColors[index]);
          newColumns.push(
            `${i18n.t("reports.CONTROL_CENTER_TOOLTIP_LABEL")}: ${val.controlCenter} 
            ${i18n.t("reports.TIME_TOOLTIP_LABEL")}: ${statistic.time} 
            ${i18n.t("reports.COUNT_ORDERS_TOOLTIP_LABEL")}: ${val.countOrders}`
          );
        }        
      });

      columns.push(newColumns);
    });
  } else {
    columns = data.reportDeliveryTimeStatistics.map(statistic => [statistic.time, 0]);
  }

  return { headers, columns, colors: controlCenters.map(m=> m.color), isPeriod: true };
}

export function getReportControlCenterAverageDeliveryTimeChartModelData(data) {
  if(!((((data || {}).reportDeliveryTimeStatistics || [])[0] || {}).values || []).length) return null;
  return checkIsPeriod(data)
    ? getReportControlCenterAverageDeliveryTimePeriodChartModelData(data)
    : getReportControlCenterAverageDeliveryTimeDayChartModelData(data);
}

export function getReportControlCenterAverageDeliveryTimeDayChartModelData(data) {
  let headers = [i18n.t("reports.AVERAGE_DELIVERY_TIME")];
  let columns = [];  

  data.reportDeliveryTimeStatistics[0].values.forEach(f=> {
    headers.push(f.controlCenter);
    headers.push({ type: "string", role: "style" });
    headers.push({ type: "string", role: 'annotation' });
  });
  
  if(data.reportDeliveryTimeStatistics.some(statistic => statistic.values.length)) {
    data.reportDeliveryTimeStatistics.forEach(statistic=> {
      let newColumnValue = [statistic.time];
      statistic.values.forEach((val, index)=> {
        newColumnValue.push(val.averageDeliveryTime / 1000 / 60);
        newColumnValue.push(defaultControlCenterColors[index]);
        newColumnValue.push(getFormatRelativeTime(val.averageDeliveryTime));
      });

      columns.push(newColumnValue);
    });
  } else {
    columns = data.reportDeliveryTimeStatistics.map(statistic => [statistic.time, 0]);
  }

  if(!columns.length) {
    headers.push({ type: "string", label: i18n.t("reports.TOTAL") });
    columns.push([`${new Date().getHours()}:00`, 0]);
  }

  return { headers, columns };
}

export function getReportControlCenterAverageDeliveryTimePeriodChartModelData(data) {
  const controlCenters = (data.reportDeliveryTimeStatistics || []).reduce((acc, statistic)=> {
    const newControlCenters = statistic.values
      .filter(f=> checkReportControlCenter(f.controlCenterId) && !acc.find(a=> a.controlCenterId === f.controlCenterId))
      .map((m, index)=> ({ 
        controlCenterId: m.controlCenterId, 
        controlCenter: m.controlCenter,
        color: defaultControlCenterColors[index]
      }))
    return acc.concat(newControlCenters);
  }, []);

  let headers = [i18n.t("reports.AVERAGE_DELIVERY_TIME")];
  let columns = [];  

  controlCenters.forEach(f=> {
    if(checkReportControlCenter(f.controlCenterId)) {
      headers.push(f.controlCenter);
      headers.push({ type: "string", role: "style" });
      headers.push({ type: "string", role: "tooltip" });  
    }
  });

  if(!controlCenters.length) {
    return null;
  }
  
  if(data.reportDeliveryTimeStatistics.some(statistic => statistic.values.length)) {
    data.reportDeliveryTimeStatistics.forEach(statistic=> {
      let newColumns = [];
      newColumns.push(statistic.date);

      statistic.values.forEach((val, index)=> {
        if(checkReportControlCenter(val.controlCenterId)) {
          const cc = controlCenters.find(f=> f.controlCenterId === val.controlCenterId) || {};
          const averageValue = (val.averageDeliveryTime || 0) / 1000 / 60;
          newColumns.push(averageValue);
          newColumns.push(cc.color || defaultControlCenterColors[index]);
          newColumns.push(
            `${i18n.t("reports.CONTROL_CENTER_TOOLTIP_LABEL")}: ${val.controlCenter} 
            ${i18n.t("reports.TIME_TOOLTIP_LABEL")}: ${statistic.time} 
            ${i18n.t("reports.AVERAGE_TIME_TOOLTIP_LABEL")}: ${getFormatRelativeTime(val.averageDeliveryTime)}`
          );
        }        
      });

      columns.push(newColumns);
    });
  } else {
    columns = data.reportDeliveryTimeStatistics.map(statistic => [statistic.time, 0]);
  }

  if(!columns.length) {
    headers.push({ type: "string", label: i18n.t("reports.TOTAL") });
    columns.push([`${new Date().getHours()}:00`, 0]);
  }

  return { headers, columns, colors: controlCenters.map(m=> m.color), isPeriod: true };
}

export function getReportDayAverageDeliveryTimeChartModelData(data) {
  if(!data || !data.controlCenterStatistics || !data.controlCenterStatistics.length) return null;

  let headers = [i18n.t("reports.AVERAGE_DELIVERY_TIME")];
  let columns = [new Date().toLocaleDateString()];

  data.controlCenterStatistics.forEach((statistic, index)=> {
    headers.push(statistic.name);
    headers.push({ type: "string", role: "style" });
    headers.push({ type: "string", role: 'annotation' });

    columns.push(statistic.dayAverageDeliveryTime / 1000 / 60);
    columns.push(defaultControlCenterColors[index]);
    columns.push(getFormatRelativeTime(statistic.dayAverageDeliveryTime));
  });
  
  return { headers, columns: [columns] };
}

export function getSalesChartModelData(data, keyForX = "count") {
  const headers = [{type: "date", label: i18n.t("sales.DATE")}, {type: "number", label: i18n.t("sales.COUNT")}];
  const columns = []
  data.forEach(v => {
    columns.push([new Date(v.id), v[keyForX]]);
  })

  return { headers, columns: columns };
}

export function getDeepLinkStatsChartModelData(data) {
  if(!data) {
    return null;
  }

  return {
    headers: [
      { type: "string", label: i18n.t("settings.deepLink.EVENT") },
      { type: "number", label: i18n.t("settings.deepLink.COUNT") },
      { role: "style" },
      { role: "annotation" }
    ],
    columns: data.map((statistic, index) => [
      DEEP_LINK_EVENT[statistic.event] + " " + statistic.platform,
      statistic.count,
      defaultControlCenterColors[index],
      statistic.count,
    ])
  };
}

export const createCustomHTMLContent = (value, isFullWidth = true) => {
  let html = '<div style="display:flex;flex-wrap:wrap;width:270px;padding:5px 5px 5px 5px;">';
  if(Array.isArray(value)) {
    (value.forEach(val=> {
      html +=`<div style="${isFullWidth ? "width:100%;text-align:start;" : "width:50%"}">${val.title}: ${val.value}</div>`;
    }));
  }
  html +='</div>';
  return html;
}

const checkReportControlCenter = controlCenterId => {
  return isSingleDepotMode() || controlCenterId !== i18n.t("reports.TOTAL")
}

const checkIsPeriod = data => {
  return [...new Set(((data || {}).reportDeliveryTimeStatistics || [])
    .filter(deliveryTimeStatistic=> deliveryTimeStatistic.date 
      && (deliveryTimeStatistic.values || []).some(s=> checkReportControlCenter(s.controlCenterId))
    ).map(deliveryTimeStatistic=> deliveryTimeStatistic.date))
  ].length > 1;
}
